import {PlusOutlined} from '@ant-design/icons';
import {Badge, Button, Form} from 'antd';
import React, {FC, useState} from 'react';

import {MainInfoTerritoryItem} from './main-info-international-block';

export const MainInfoTerritoriesList: FC = () => {
    const [isOpen, setIsOpen] = useState<boolean>(true);

    const toggleOpen = () => {
        setIsOpen((prev) => !prev);
    };

    return (
        <div
            className="form-flex"
            style={{
                maxHeight: 'calc(min(600px, 64vh))',
                overflow: 'auto',
                paddingRight: 8,
                width: '100%',
            }}
        >
            <Form.List name="territories">
                {(fields, {add, remove}) => (
                    <>
                        <Badge
                            count={!isOpen ? fields.length : undefined}
                            className="text-project-badge add-project-badge"
                        >
                            <Button
                                type="text"
                                className="text-button"
                                onClick={toggleOpen}
                            >
                                <h4>Территории реализации инвестиционного проекта</h4>
                            </Button>
                        </Badge>
                        {isOpen && (
                            <>
                                <Badge count={fields.length} className="add-project-badge">
                                    <Button
                                        type="primary"
                                        onClick={() => add()}
                                        icon={<PlusOutlined />}
                                        className="add-project-button"
                                    >
                                        Добавить территорию
                                    </Button>
                                </Badge>

                                {fields.map((field, index) => (
                                    <MainInfoTerritoryItem
                                        key={field.key}
                                        field={field}
                                        index={index}
                                        onRemove={remove}
                                    />
                                ))}
                            </>
                        )}
                    </>
                )}
            </Form.List>
        </div>
    );
};
